import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WarningBoxComponent } from '../human-resource/warning-box/warning-box.component';
import { LoginService } from '../services/login.service';
import { MasterDataService } from '../services/master-data.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  @Input() childMessage: string;
  @Output() toggleDocumentNavEvent = new EventEmitter<boolean>();
  @Output() toggleSideNavEvent = new EventEmitter<boolean>();

  panelOpenState = false;
  menuList: any;
  isStandardReports = false;
  userId;
  // menuList = [{"id":"1","name":"Diary Management","submenus":[{"id":"1","name":"My Diaries"},{"id":"2","name":"My Pending Approvals"},{"id":"3","name":"My Pending Submission"}]},{"id":"2","name":"Human Resource","submenus":[{"id":"1","name":"Manage Profile"},{"id":"2","name":"My Leaves"},{"id":"3","name":"My Holidays"},{"id":"4","name":"Personal Details"},{"id":"5","name":"Official Details"},{"id":"6","name":"CTC Details"}]},{"id":"3","name":"Organization Setup","submenus":[{"id":"1","name":"Conveyance Rates"},{"id":"2","name":"Standard Rates"},{"id":"3","name":"Branchwise Holidays"},{"id":"4","name":"Clients"},{"id":"5","name":"Company Configuration"},{"id":"6","name":"Article Stipend Master"}]},{"id":"4","name":"Management","submenus":[{"id":"1","name":"Manpower Budgeting"},{"id":"2","name":"Copy Budget"}]},{"id":"5","name":"Document Management","submenus":[{"id":"1","name":"Libraries"}]},{"id":"6","name":"Master Data","submenus":[{"id":"1","name":"Assignments"},{"id":"2","name":"Tasks"},{"id":"3","name":"Branch"},{"id":"4","name":"Financial Year"},{"id":"5","name":"Roles"},{"id":"6","name":"Designations"},{"id":"7","name":"Locations"}]}]

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private masterDataService: MasterDataService
  ) { }

  ngOnInit() {
    this.userId=localStorage.getItem('id');
    this.loadMenus();
  }

  selectedMenuItem;
  arrowDownIndex = []
  listItemClick(item,index){
   this.selectedMenuItem=item
   if(this.arrowDownIndex.includes(index)){
    var popindex = this.arrowDownIndex.indexOf(index);
    console.log("this.popindex", popindex)
    if (index !== -1) {
    this.arrowDownIndex.splice(popindex, 1);
    }
    console.log("this.arrowDownIndex if",this.arrowDownIndex)
   }else{
    this.arrowDownIndex.push(index)
    console.log("this.arrowDownIndex else",this.arrowDownIndex)
   }


   
   this.menuClick=!this.menuClick;
  }

  toggleSideNav: boolean = false;
  hideMenuSideBar() {
    this.toggleSideNav = !this.toggleSideNav;
    this.toggleSideNavEvent.emit(this.toggleSideNav);
    console.log('document management click this.toggleSideNav', this.toggleSideNav);
  }

  toggleDocumentSideNav: boolean = false;
  openDocumentManagement() {
    console.log('inside document management');
    this.toggleDocumentSideNav = !this.toggleDocumentSideNav;
    this.toggleDocumentNavEvent.emit(this.toggleDocumentSideNav);
    console.log('document management click  this.toggleDocumentSideNav', this.toggleDocumentSideNav);
  }

  // loadMenus() {
  //   this.masterDataService.getUserMenus().subscribe((res) => {
  //     this.menuList = res;
  //     for(let i=0;i<this.menuList.length;i++)
  //     {
  //         if(this.menuList[i].name=='Managing Partner' && (this.userId != 52 && this.userId != 1074 && this.userId != 51 && this.userId != 53))
  //         {
  //             this.menuList.splice(i,1);
  //         }

  //     }
  //     console.log('menulist', this.menuList);
  //   });
    
  // }

  loadMenus() {
    var userId = localStorage.getItem('id');
    var roleId = localStorage.getItem('userRoleId');
    var serviceVerticalId = localStorage.getItem('serviceVerticalId');
    if(serviceVerticalId==null){
      serviceVerticalId = '0';
    }
    
    this.masterDataService.getUserMenus(roleId,serviceVerticalId, userId).subscribe((res) => {
      this.menuList = res;
      console.log('sidebarroleId', roleId);
    console.log('sidebarserviceVerticalId', serviceVerticalId);
    console.log('sidebaruserId', userId);
      for(let i=0;i<this.menuList.length;i++)
      {
          if(this.menuList[i].name=='Managing Partner' && (this.userId != 52 && this.userId != 1074 && this.userId != 51 && this.userId != 53))
          {
              this.menuList.splice(i,1);
          }

      }
      console.log('menulist', this.menuList);
      localStorage.setItem('menuList',JSON.stringify(this.menuList.accessControl));
      localStorage.setItem('accessResponse',JSON.stringify(this.menuList));
    });
    
  }

  menuClick:boolean;
  onDocumentMenuClick(menu ) {
    // this.menuClick=true;
    var x = localStorage.getItem('userDocStatus');
    if (menu.name === 'Document Management' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/document-list');
      console.log('inside menu condition');
      this.hideMenuSideBar();
      this.openDocumentManagement();
      // this.router.navigateByUrl('dashboard/document-management');
    }else if(menu.name === 'Dashboard' && x == 'Submitted'){
      this.router.navigateByUrl('dashboard/main-dashboard');
    }else if(menu.name === 'Managing Partner' && x == 'Submitted'){
      this.router.navigateByUrl('dashboard/app-all-partners-dashboard');  
    }else if(menu.name === 'Announcements' && x == 'Submitted'){
      this.router.navigateByUrl('dashboard/manage-announcement')
    }else if (menu.name === 'Reports' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/report-list');
    }else if(menu.name === 'User Details' && x == 'Submitted'){
      this.router.navigateByUrl('dashboard/user-data-list');
    }else if(menu.name==='Standard Reports' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/my-report-list')
    }else if(menu.name==='Master Data' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/master-data-list')
    }else if(menu.name==='HR Reports' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/hr-report-list')
    }else if(menu.name==='Account Reports' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/account-report-list')
    }else if(menu.name==='Access Control' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/access-privilege')
    }else if(menu.name==='Partner Reports' && x=='Submitted'){
      this.router.navigateByUrl('dashboard/partner-report-list')
    }
  }

  selectedSubmenuItem;
  onChangeMenuClick(submenu, menu) {
    // this.onDocumentMenuClick(menu);
    this.selectedSubmenuItem =
    submenu.subMenu ? submenu.subMenu : submenu.subMenu;
    var x = localStorage.getItem('userDocStatus');
    console.log('x', x);
    console.log('menu.name', menu.name);
    console.log('submenu.subMenu', submenu.subMenu);
    if (
      submenu.subMenu === 'My Diaries' &&
      menu.name === 'Diary Management' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/my-diary');
    } else if (submenu.subMenu === 'My Pending Submission' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-pending-submission');
    } else if (submenu.subMenu === 'My Pending Approvals' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-pending-approval');
    } else if (submenu.subMenu === 'My Leaves' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-leaves');
    } else if (submenu.subMenu === 'Assignments' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-assignment');
    } else if (submenu.subMenu === 'Tasks' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-task');
    } else if (submenu.subMenu === 'Branch' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-branch');
    } else if (submenu.subMenu === 'Financial Year' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-financial-year');
    } else if (submenu.subMenu === 'Roles' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-role');
    } else if (submenu.subMenu === 'Designations' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-designation');
    }
    // else if (submenu.subMenu === 'Locations' && x == 'Submitted') {
    //   this.router.navigateByUrl('dashboard/manage-location');
    // }
    else if (submenu.subMenu === 'Conveyance Rates' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/conveyance-rates');
    } else if (submenu.subMenu === 'Standard Rates' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/standard-rates');
    } else if (submenu.subMenu === 'Branchwise Holidays' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/branch-holidays');
    } else if (submenu.subMenu === 'Clients' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-client');
    } else if (submenu.subMenu === 'MIS' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/management-information-system');
    } else if (submenu.subMenu === 'Company Configuration' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/comapny-configuration');
    } else if (submenu.subMenu === 'Manpower Budgeting' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manpower-budget');
    } else if (submenu.subMenu === 'Article Stipend Master' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/article-stipend');
    } else if (submenu.subMenu === 'Manage Profile' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-profile');
    } else if (submenu.subMenu === 'CTC Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/ctc-details');
    } else if (submenu.subMenu === 'Official Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/official-details');
    } else if (submenu.subMenu === 'Personal Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/personal-details');
    } else if (submenu.subMenu === 'Diary Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/diary-details');
    } else if (
      submenu.subMenu === 'My Diaries' &&
      menu.name === 'Standard Reports' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/sr-my-diaries');
    } else if (submenu.subMenu === 'My Leave Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/sr-my-leaves');
    } else if (submenu.subMenu === 'Employee Leave Summary' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/hr-my-leaves');
    } else if (submenu.subMenu === 'Employee Salary Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/salary-report');
    } else if (submenu.subMenu === 'Article Stipend' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/stipend-report');
    } else if (submenu.subMenu === 'Penalty Summary' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/penalty-summary-report');
    } else if (
      submenu.subMenu === 'Annual Independence Declaration' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/all-independence-declaration');
    } else if (submenu.subMenu === 'Budget' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/budget-report');
    } else if (submenu.subMenu === 'Client Billing' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/client-billing');
    } else if (
      submenu.subMenu === 'My Annual Independence Declaration' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/my-all-independence-declaration');
    } else if (submenu.subMenu === 'My Penalty Summary' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-penalty-summary');
    } else if (submenu.subMenu === 'Article 1/6th Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/article-one-sixth-report');
    } else if (submenu.subMenu === 'My Salary Closing' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-salary-closing');
    } else if (submenu.subMenu === 'My Article 1/6 Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-article-one-sixth-report');
    } else if (submenu.subMenu === 'My Unapproved Diaries' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-unapproved-diaries');
    } else if (submenu.subMenu === 'Manage Announcement' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-announcement');
    } else if (submenu.subMenu === 'Empanelment Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/empanelment-report');
    } else if (
      submenu.subMenu === 'Client Conveyance Summary' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/client-conveyance-summary');
    } else if (
      submenu.subMenu === 'Client Conveyance Assignment' &&
      x == 'Submitted'
    ) {
      this.router.navigateByUrl('dashboard/client-conveyance-assignment');
    } else if (submenu.subMenu === 'My Stipend' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-stipend-report');
    } else if (submenu.subMenu === 'Monthly Conveyance' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/monthly-conveyance-report');
    } else if (submenu.subMenu === 'Monthly Conveyance Details' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/monthly-conveyance-detail-report');
    }
    else if (submenu.subMenu === 'Overtime Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/overtime-report');
    }
    else if (submenu.subMenu === 'Article Availability' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/article-availability-report');
    } else if (submenu.subMenu === 'My Sheets' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/travel-sheet');
    } else if (submenu.subMenu === 'My Pending Sheet Approval' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-pending-travel-sheet-approvals');
    } else if (submenu.subMenu === 'Submitted Sheets' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/submitted-sheets');
    } else if (submenu.subMenu === 'My Unapproved Sheets' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-unapproved-travel-sheet');
    } else if (submenu.subMenu === 'Role wise Budgeted Vs Actual Cost Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/budget-vs-actual-cost');
    } else if (submenu.subMenu === 'My Role wise Budgeted Vs Actual Cost Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-budget-vs-actual-cost');
    }else if (submenu.subMenu === 'Bank Payment report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/bank-payment');
    }
    else if (submenu.subMenu === 'Annual Salary Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/annual-salary-report');
    }
    else if (submenu.subMenu === 'Salary Slip' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/salary-slip');
    }
    else if (submenu.subMenu === 'Article Debit Credit Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/article-debit-credit-hours');
    } else if (submenu.subMenu === 'Exit Form' && x == 'Submitted') {
      this.router.navigate(['dashboard/exit-form']);
    } else if (submenu.subMenu === 'Exit Form Summary' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/exit-form-summary');
    }else if (submenu.subMenu === 'Commitment Letter' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/commitment-letter');
    }else if (submenu.subMenu === 'Contract Letter' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/contract-letter');
    }else if (submenu.subMenu === 'Annual Stipend Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/annual-stipend-report');
    } else if (submenu.subMenu === 'Expense Reimbursement Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/expense-reimbursement-report');
    } else if (submenu.subMenu === 'My Actual Task Summary Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-actual-task-report');
    } else if (submenu.subMenu === 'Actual Task Summary Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/actual-task-report');
    } else if (submenu.subMenu === 'Software Management' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/software-assets-management');
    }
    else if (submenu.subMenu === 'Hardware Management' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/hardware-assets-management');
    }else if (submenu.subMenu === 'IT Reports' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/it-report-list');
    }
    else if (submenu.subMenu === 'Asset Physical verification report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/physical-verification-report');
    }
    else if (submenu.subMenu === 'Asset Pop-up confirmations' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/popup-confirmation-report');
    }
    else if (submenu.subMenu === 'Asset History Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/transfer-history-report');
    }
    else if (submenu.subMenu === 'Update Budget' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/update-budget-excel');
    }
    else if (submenu.subMenu === 'Detailed Variance Report' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/variance-report-excel');
    } else if (submenu.subMenu === 'Know Your Colleagues' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/know-your-colleauge');
    } else if (submenu.subMenu === 'Know Your Clients' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/know-your-clients');
    } else if (submenu.subMenu === 'My Holidays' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-holidays-report');
    } else if (submenu.subMenu === 'Announcement History' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/manage-announcement-history');
    }else if (submenu.subMenu === 'Article Vacancy' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/article-vacancy');
    }else if (submenu.subMenu === 'My Targets' && x == 'Submitted') {
      this.router.navigateByUrl('dashboard/my-target-report');
    }else {
      if (x == 'Pending') {
        this.warningBox();
      } else {
        this.router.navigateByUrl('dashboard/under-construction');
      }
    }
  }

  getIconClass(name) {
    var iconName = '';
    if(name=='Dashboard'){
    iconName='fa fa-tachometer';
    }else if(name=='Managing Partner'){
      iconName='fa-address-card';
    }else if(name=='User Details'){
      iconName = 'fa fa-user-o';
    }else if(name=='Announcements'){
      iconName = 'fa fa-bullhorn'
    }else if (name == 'Diary Management') {
      iconName = 'fa fa-briefcase';
    }else if(name=='Travel Sheet Management'){
      iconName = 'fa fa-money'
    }else if(name=='Document Management'){
      iconName = 'fa fa-file-text-o'
    }else if (name == 'Asset Management') {
      iconName = 'fa fa-laptop';
    }else if (name == 'Master Data') {
      iconName = 'fa fa-database';
    }else if (name == 'Human Resource') {
      iconName = 'fa fa-archive';
    }else if (name == 'Account') {
      iconName = 'fa fa-sticky-note-o';
    }else if (name == 'Management') {
      iconName = 'fa fa-user-plus';
    }else if (name == 'Access Control') {
      iconName = 'fa fa-shield';
    }else if (name=='Reports' || name == 'Standard Reports' || name=='HR Reports' || name=='Account Reports' || name=='Analytical Reports' || name=='Partner Reports') {
      iconName = 'fa fa-bar-chart';
    }else {
      if(name==this.selectedSubmenuItem){
      iconName = 'fa fa-circle';
      }else{
        iconName = 'fa fa-circle-thin';
      }
    }

    return iconName;
  }

  warningBox() {
    this.dialog.open(WarningBoxComponent);
  }

}
